import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'lingui-react';
import { QuickActionButton } from 'base-components';

import { buildAssetDetailLink } from 'utils/hybridLinks';

import withConnectedData from './Container';
import messages from './messages';

export function CaseClassicAssetDetailButton({
  assetInfo,
  tenant,
  userProfile: {
    companyId,
  },
}) {
  const assetDetailLink = buildAssetDetailLink(assetInfo.id, { companyId, tenant });
  return (
    <a href={assetDetailLink}>
      <QuickActionButton>
        <QuickActionButton.Icon name="long-arrow-left" modifiers={['left']} />
        <QuickActionButton.Text>
          <Trans id={messages.title} />
        </QuickActionButton.Text>
      </QuickActionButton>
    </a>
  );
}

CaseClassicAssetDetailButton.propTypes = {
  assetInfo: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  tenant: PropTypes.string.isRequired,
  userProfile: PropTypes.shape({
    companyId: PropTypes.string,
  }).isRequired,
};

export default withConnectedData(CaseClassicAssetDetailButton);



// WEBPACK FOOTER //
// ./compositions/CaseClassicAssetDetailButton/index.js